/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type SpecialtyServiceOptionsEnum =
  (typeof SpecialtyServiceOptionsEnum)[keyof typeof SpecialtyServiceOptionsEnum];

export const SpecialtyServiceOptionsEnum = {
  'dog-training': 'dog-training',
  'on-demand-grooming': 'on-demand-grooming',
} as const;
